import platform from "platform"

const appshell = {
  size: {
    width: window.innerWidth,
    height: window.innerHeight
  },
  platform: platform,
  declinedPWA: localStorage.getItem("declined-pwa") ? (localStorage.getItem("declined-pwa") && eval(localStorage.getItem("declined-pwa"))):false,
  installedPWA: localStorage.getItem("installed-pwa") ? (localStorage.getItem("installed-pwa") && eval(localStorage.getItem("installed-pwa"))) : false,
  connected: navigator.onLine,
  dark: localStorage.getItem("dark") ? (localStorage.getItem("dark") && eval(localStorage.getItem("dark"))) : true,
  mini: localStorage.getItem("mini") ? (localStorage.getItem("mini") && eval(localStorage.getItem("mini"))) : false,
  activeRequests: 0,
  sysNotifications: [],
  updateInProgress: false
};

export default appshell;